import { NewType, UpdateType } from './removeDates';

export interface InstallationSite {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export type NewInstallationSite = NewType<InstallationSite, 'name'>;

export type UpdateInstallationSite = UpdateType<InstallationSite, 'name'>;

export const EmptyNewInstallationSite: NewInstallationSite = {
  name: '',
};

export const EmptyInstallationSite: InstallationSite = {
  id: 0,
  name: '',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
};
